import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './App.tsx';
import './index.css';
import './infrastructure/theme/fonts.css';
import './react-pdf-worker.ts';
import './sentry.ts';
import { setupConsoleScrubber } from './infrastructure/sentry/piiScrubber';

setupConsoleScrubber();

const container = document.getElementById('root')!;
createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler(),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>
);
